import Container from "../../../utils/Container";
import loginImage from "../../../assets/banner/login.jpg";
import DhoorbinOutline from "../../../assets/icons/dhoorbin-outline.svg";
import BangladeshFlag from "../../../assets/icons/bangladesh.svg";
import { Link, useNavigate } from "react-router";
import { useState } from "react";
import toast from "react-hot-toast";
import { registerApi } from "../../../api/website/auth/auth";
const SignUp = () => {
  const navigate = useNavigate();
  const [FormData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    password: "",
    isCustomer: 1,
    isWelcomed: 1,
    status: 1,
    createdAt: new Date().toISOString(),
  });
  const [IsLoading, setIsLoading] = useState(false);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = () => {
    if (
      FormData.fullName === "" ||
      FormData.email === "" ||
      FormData.phoneNumber === "" ||
      FormData.password === ""
    ) {
      toast.error("Please fill all the fields");
    } else {
      registerApi(FormData, setFormData, navigate, setIsLoading);
    }
  };
  return (
    <Container>
      <div className="py-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 p-0 lg:p-10">
          <div className="hidden lg:block w-[600px] h-[600px] overflow-hidden rounded-lg">
            <img
              className="w-full h-full object-cover"
              src={loginImage}
              alt=""
            />
          </div>
          <div className="flex flex-col items-center gap-y-3 p-0 lg:p-5">
            <div className="text-center py-8 relative">
              <p className="font-bold text-3xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                Register Now! Go Beyound
              </p>
              <span className="text-sm text-black/50">
                Your World of Travel, Just One Click Away!
              </span>
              <div className="absolute -top-8 lg:-top-24 left-1/2 transform -translate-x-1/2 w-[200px] lg:w-[280px] opacity-60">
                <img className="" src={DhoorbinOutline} alt="" />
              </div>
            </div>
            <div className="w-full px-5 space-y-5">
              <div>
                <label htmlFor="password" className="text-black/60 text-xs">
                  Full Name <small>(Legal Name)</small>
                </label>
                <input
                  type="text"
                  placeholder="Enter your full name"
                  className="border w-full px-10 py-3 rounded-md focus:outline-none"
                  value={FormData.fullName}
                  onChange={handleChange}
                  id="fullName"
                />
              </div>
              <div className="relative">
                <label htmlFor="phoneNumber" className="text-black/60 text-xs">
                  Phone Number
                </label>
                <input
                  type="text"
                  placeholder="Enter Phone Number"
                  className="border w-full px-12 py-3 rounded-md focus:outline-none"
                  value={FormData.phoneNumber}
                  onChange={handleChange}
                  id="phoneNumber"
                />
                <div className="absolute top-9 left-2 w-7 h-7 overflow-hidden rounded-lg bg-white">
                  <img
                    className="w-full h-full object-cover"
                    src={BangladeshFlag}
                    alt=""
                  />
                </div>
              </div>
              <div>
                <label htmlFor="password" className="text-black/60 text-xs">
                  Email
                </label>
                <input
                  type="text"
                  placeholder="Enter your email address"
                  className="border w-full px-10 py-3 rounded-md focus:outline-none"
                  value={FormData.email}
                  onChange={handleChange}
                  id="email"
                />
              </div>
              <div>
                <label htmlFor="password" className="text-black/60 text-xs">
                  Password
                </label>
                <input
                  type="text"
                  placeholder="Enter your password"
                  className="border w-full px-10 py-3 rounded-md focus:outline-none"
                  value={FormData.password}
                  onChange={handleChange}
                  id="password"
                />
              </div>
              <div>
                <button
                  onClick={handleSubmit}
                  className="bg-[#153875] w-full py-3 rounded-lg text-white text-sm font-semibold scale-100 hover:scale-105 duration-300 active:scale-95"
                  disabled={IsLoading ? true : false}
                >
                  {IsLoading ? "Processing" : "  Sign Up"}
                </button>
              </div>
              {/* <div className="py-5 relative">
                <hr />
                <div className="absolute top-1/2 -translate-y-1/2 left-1/2 transform -translate-x-1/2 text-xs bg-[#ffffffb4] text-black/50 px-5 border py-0.5 rounded-md">
                  OR
                </div>
              </div>
              <div className="px-4">
                <button className="w-full border py-3 rounded-lg scale-100 hover:scale-105 duration-300 active:scale-95">
                  <div className="flex justify-center items-center gap-x-4">
                    <FaFacebook className="text-[#2155ad] text-lg" />
                    <p className="text-black/80 text-sm">Login With Facebook</p>
                  </div>
                </button>
              </div>
              <div className="px-4">
                <button className="w-full border py-3 rounded-lg scale-100 hover:scale-105 duration-300 active:scale-95">
                  <div className="flex justify-center items-center gap-x-4">
                    <FaGoogle className="text-[#ff002b] text-lg" />
                    <p className="text-black/80 text-sm">Login With Google</p>
                  </div>
                </button>
              </div> */}
              <div className="flex justify-center items-center">
                <Link to={"/authentication/signin"}>
                  <button className="text-[#2155ad] text-xs font-semibold cursor-pointer">
                    Do you have an account?
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SignUp;
